import React from 'react';
import {
  Button,
  Alert
} from 'reactstrap';

export const filtersToQueryParams = (event, columns) => {
  const query = {}
  _.each(event.filters, (value, key) => {
    const column = _.find(columns, column => column.field === key);

    if (!column) return;
    if (!column?.filter?.enabled) return;

    if (column?.filter?.filterrific?.search && isCustomField(column) && column?.filter?.filterrific?.searchKey) {
      if (!query[column.filter.filterrific.search]) {
        query[column.filter.filterrific.search] = {};
      }
      query[column.filter.filterrific.search][column.filter.filterrific.searchKey] = value?.value || '';
    } else if (column?.filter?.filterrific?.search) {
      query[column.filter.filterrific.search] = value?.value;
    }
  })

  query['show_all'] = event.filters['show_all']?.value || false;

  return { ...event, filters: query }
}

export const sortToQueryParams = (event, columns) => {
  let column = _.find(columns, { field: event?.sortField })

  let filterrific = column?.sort?.filterrific?.sort || ''

  if (!column || !column?.sort?.enabled) {
    return event
  };

  let sort = {}

  if (filterrific) {
    sort = { sorted_by: `${filterrific}${event?.order}` }
  }

  return { ...event, sort }
}

const isCustomField = (column) => {
  return column?.configuration?.isCustomField || false;
}

export const clearButton = (options) => {
  return (
    <Button
      color='primary'
      block={true}
      onClick={options.filterClearCallback}
    >
      {I18n.t('actions.clean')}
    </Button>
  )
}

export const emptyMessage = options => {
  return (
    <Alert color='warning'>
      {I18n.t('messages.without_results')}
    </Alert>
  )
}

export const onDataTableChange = (event, dataTableColumns, setQueryFilterParams) => {
  if (event.type == 'filter') {
    event = filtersToQueryParams(event, dataTableColumns);
  } else if (event.type == 'sort') {
    event = sortToQueryParams(event, dataTableColumns);
  }

  setQueryFilterParams(event);
}

// export const onSelectionChange = (event, records, selectedRecords) => {
//   let { value, type } = event;
//   let { checked } = event.originalEvent;

//   let _selectedRecords = [ ... selectedRecords || []];

//   if(type == 'all' && checked){
//     _.each(value, record => {
//       _selectedRecords.push(record);
//     })
//   } else if(type == 'all' && !checked){
//     _.remove(_selectedRecords, record => {
//       return _.includes(_.map(records, 'id'), record.id);
//     });
//   } else {
//     _selectedRecords = value;
//   }

//   return _.uniqBy(_selectedRecords, 'id')
// }
